export const GREENHOUSE_ID = import.meta.env.GREENHOUSE_ID ?? 'dev';
export const APP_NAME = 'Inevitable Cloud';
